import type { ContentElementInterviewProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: 'prose-sm md:prose dark:!text-foreground dark:prose-strong:text-foreground content-element-padding',
  interviewLine: 'mb-8',
  interviewText: 'first-of-type:[&>p]:inline inline',
} as ContentElementInterviewProps['classProps'];

export default classProps;
